import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Home from './pages/Home';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import BrandStory from './pages/BrandStory';
import DealerHub from './pages/DealerHub';
import Impact from './pages/Impact';
import AdminLeads from './pages/AdminLeads';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <div className="App">
      <Router>
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/:id" element={<ProductDetail />} />
            <Route path="/brand-story" element={<BrandStory />} />
            <Route path="/dealer-hub" element={<DealerHub />} />
            <Route path="/impact" element={<Impact />} />
            <Route path="/admin/mock-leads" element={<AdminLeads />} />
          </Routes>
        </main>
        <Footer />
      </Router>
    </div>
  );
}

export default App;